module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-driver-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label pb-0"
  }, [_vm._v("Group")]), _c('div', {
    staticClass: "field m-0"
  }, [_vm._v("G" + _vm._s(_vm.item.id) + " " + _vm._s(_vm.item.name))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Policies")]), _c('div', {
    staticClass: "field m-0"
  }, [_vm._v(_vm._s(_vm.item.policies.length))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Supervisor")]), _c('br'), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.supervisor),
      expression: "item.supervisor"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.item.supervisor) ? _vm._i(_vm.item.supervisor, null) > -1 : (_vm.item.supervisor)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.item.supervisor,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.item, "supervisor", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.item, "supervisor", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.item, "supervisor", $$c)
        }
      }, function($event) {
        return _vm.$emit('toggleSupervisor', _vm.item)
      }]
    }
  })]), _c('div', {
    staticClass: "column shrink"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'bottom'
    }
  }, [_c('DriverGroupButtons', {
    attrs: {
      "item": _vm.item,
      "driver": _vm.driver
    }
  })], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f665bae0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/DriverGroup.vue
// module id = 2729
// module chunks = 1